module.exports = __webpack_public_path__ + "plane_paper_1.f945cdfc3ac64a2d706871360cf596f2.svg";